<template>
    <div class="posts-wrapper">
      <div class="packages memberships">
                
        <div class="box-white-wrapper" v-if="packages.length > 0">
            <div class="edit-button" v-if="customer != ''">
                <router-link :to="`/admin/membership/detail/${customer.memberof}`"><feather type="arrow-left"/>Regresar</router-link>
            </div>

            <div class="user-header" v-if="customer != ''">
                <div class="item">
                    <span>Nombre:</span>
                    {{ customer.firstName }} {{ customer.lastName }}
                </div>
                <div class="item">
                    <span>Cant. Libras:</span>
                    {{ totalPounds }}
                </div>
                <div class="item">
                    <span>Cant. Paquetes:</span>
                    {{ packages.length }}
                </div>
                <div class="item">
                    <span>Total CashBox:</span>
                    ${{ totalCashback }}
                </div>
            </div>
          <vs-table :data="packages" pagination max-items="50" :key="keyPackages">
              <template slot="thead">
                  <vs-th sort-key="tracking">Tracking</vs-th>
                  <vs-th sort-key="createdAt">Fecha</vs-th>
                  <vs-th sort-key="weight">Cant Libras</vs-th>
                  <vs-th sort-key="invoiced">Número Factura</vs-th>
                  <vs-th sort-key="feTotalTrasporte" >Monto Facturado</vs-th>
                  <vs-th sort-key="cashback">CashBox</vs-th>
                  <!-- <vs-th sort-key="id" class="width-30"></vs-th> -->
              </template>
              <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                    <vs-td :data="data[indextr].tracking">{{data[indextr].tracking}}</vs-td>
                    <vs-td :data="data[indextr].cantidadLibras">
                        {{data[indextr].createdAt | moment('DD/MM/YYYY')}}
                    </vs-td>
                    <vs-td :data="data[indextr].weight"> {{ data[indextr].weight }}</vs-td>
                    <vs-td :data="data[indextr].invoiced"> {{ data[indextr].invoiced }}</vs-td>
                    <vs-td :data="data[indextr].feTotalTrasporte"> ${{ data[indextr].feTotalTrasporte }}</vs-td>
                    <vs-td :data="data[indextr].cashback"> ${{ data[indextr].cashback }}</vs-td>
                    <!-- <vs-td :data="data[indextr].invoiced">
                        <div class="table-actions" v-if="userInfoData.role != Roles.Distribuitor">
                              <router-link :to="`/customer/casback/detail/${data[indextr].id}`"><feather type="eye"/></router-link>
                        </div>
                    </vs-td>                     -->
                  </vs-tr>
              </template>
          </vs-table>
        </div>
      </div>
    </div>
</template>
<script>
import { mapState, } from 'vuex'
import {helper} from '@/helpers/utils'
import { Role } from '@/helpers/Role.js'
import MembershipService from "@/services/MembershipService"
export default {
    name: 'MemberDetailView',
    mixins: [helper],
    data () {
        return {
            textarea: "",
            keyPackages: 0,
            noLimit: false,
            typeChangeSt: false,
            Roles: [],
            boxActive: null,
            keyword: "",
            filterObj: {
                dateFilter: null,
                status: null,
                filter: ""
            },
            packages: [],
            line: "",
            customer: "",
            totalCashback: "",
            totalPounds: ""
        }
    },
    created(){
        this.Roles = Role
        this.$Progress.start();
        if(this.userInfoData.role != this.Roles.Admin){
            this.$router.push('/')
        }
        this.getMembersDetailAd(this.$route.params.id)
        this.$Progress.finish()
    },
    computed: {
        ...mapState([
        'userInfoData'
        ]),
    },
    methods: {
        
        async getMembersDetailAd (id ) {
            let response = await MembershipService.getMembersDetailAd({memberId: id})
            console.log(response)
            if((response.status / 100) == 2) {
                this.packages = response.data.packages
                this.customer = response.data.customer
                this.totalPounds = response.data.totalPounds
                this.totalCashback = response.data.totalCashback
                // this.line = response.data.line
            
            }
        },
        
    }
}
</script>
